import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createSlots as _createSlots, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "q-ml-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_chevron_left_icon = _resolveComponent("chevron-left-icon")!
  const _component_d_button = _resolveComponent("d-button")!
  const _component_select_header = _resolveComponent("select-header")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_btn_group = _resolveComponent("q-btn-group")!
  const _component_channel_details = _resolveComponent("channel-details")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.userscope?.channels && _ctx.fromProduct)
      ? (_openBlock(), _createBlock(_component_d_button, {
          key: 0,
          class: "q-mb-lg from-product",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$router.push({name: 'ProductDetailIndex', params: { productId: _ctx.fromProduct.sys.id }})), ["prevent"])),
          flat: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_chevron_left_icon),
            _createElementVNode("span", _hoisted_1, "Back to \"" + _toDisplayString(_ctx.fromProduct.title) + "\"", 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.userscope?.channels)
      ? (_openBlock(), _createBlock(_component_select_header, {
          key: 1,
          class: "catalogue-select",
          "model-value": _ctx.active,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.setActiveCatalogueFromNav($event.sys.id))),
          options: _ctx.catalogues,
          "onUpdate:options": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.catalogues) = $event)),
          loading: _ctx.loading,
          "onUpdate:loading": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.loading) = $event)),
          placeholder: _ctx.loading ? '...' : 'Select a Channel',
          "options-map": {label: 'name', value: true, subtitle: e => `${e.id}` },
          description: _ctx.loading ? '' : `${_ctx.catalogues?.length} channels`,
          "data-cy": "catalogue-select-header"
        }, null, 8, ["model-value", "options", "loading", "placeholder", "options-map", "description"]))
      : (_openBlock(), _createBlock(_component_select_header, {
          key: 2,
          class: "catalogue-select",
          "model-value": _ctx.active,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.setActiveCatalogueFromNav($event.sys.id))),
          options: _ctx.catalogues,
          "onUpdate:options": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.catalogues) = $event)),
          loading: _ctx.loading,
          "onUpdate:loading": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.loading) = $event)),
          placeholder: _ctx.loading ? '...' : 'Select a Channel',
          "create-label": "+ Channel",
          "options-map": {label: 'name', value: true, subtitle: e => `${e.id}` },
          "on-create": _ctx.createCatalogue,
          description: _ctx.loading ? '' : `${_ctx.catalogues?.length} channels`,
          "data-cy": "catalogue-select-header"
        }, _createSlots({ _: 2 }, [
          (_ctx.active)
            ? {
                name: "actions",
                fn: _withCtx(() => [
                  _createVNode(_component_q_btn_group, {
                    class: "channel-client-btns",
                    style: {"border-radius":"6px"},
                    outline: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_btn, {
                        outline: "",
                        class: _normalizeClass({active: _ctx.$route.name === 'Channels'})
                      }, {
                        default: _withCtx(() => _cache[7] || (_cache[7] = [
                          _createTextVNode("Channel")
                        ])),
                        _: 1
                      }, 8, ["class"]),
                      _createVNode(_component_q_btn, {
                        outline: "",
                        class: _normalizeClass({active: _ctx.$route.name === 'Clients'}),
                        onClick: _withModifiers(_ctx.onClientClick, ["stop"])
                      }, {
                        default: _withCtx(() => _cache[8] || (_cache[8] = [
                          _createTextVNode("Client")
                        ])),
                        _: 1
                      }, 8, ["class", "onClick"])
                    ]),
                    _: 1
                  })
                ]),
                key: "0"
              }
            : undefined
        ]), 1032, ["model-value", "options", "loading", "placeholder", "options-map", "on-create", "description"])),
    (_ctx.active)
      ? (_openBlock(), _createBlock(_component_channel_details, {
          key: 3,
          catalogue: _ctx.active,
          packing: _ctx.packing,
          "onUpdate:catalogue": _ctx.saveCatalogue,
          "onUpdate:packing": _ctx.savePacking,
          onDelete: _ctx.deleteCatalogue,
          readonly: !!_ctx.userscope?.channels
        }, null, 8, ["catalogue", "packing", "onUpdate:catalogue", "onUpdate:packing", "onDelete", "readonly"]))
      : _createCommentVNode("", true)
  ], 64))
}